module.exports = __webpack_public_path__ + "static/media/valor1.e730f232.png";